<template>
  <table class="base-table">
    <caption v-if="tableCaption" class="base-table__caption">
      <!--
                A caption is used to proivide a description of the table contents.
                This caption will be read by screen readers, it might not always make
                sense to have a caption visible but it is a good idea to have the
                caption for accessibility purposes. This has been made hidden visually
                for that purpose.
            -->
      {{ tableCaption }}
    </caption>
    <thead
      class="base-table__thead"
      :class="{
        'base-table__thead--sticky': stickyHeader,
      }"
    >
      <slot name="thead" />
    </thead>
    <tbody class="base-table__tbody">
      <slot name="tbody" />
    </tbody>
    <tfoot v-if="hasFooter" class="base-table__tfoot">
      <slot name="tfoot" />
    </tfoot>
  </table>
</template>

<script>
  export default {
    name: 'BaseTable',
    props: {
      tableCaption: {
        type: String,
        required: false,
        default: '',
      },
      hasFooter: Boolean,
      stickyHeader: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-table {
    width: 100%;
    border-collapse: collapse;
    vertical-align: middle;

    &--layout-fixed {
      table-layout: fixed;
    }

    &__caption {
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 1px;
    }
    &__thead {
      :deep(tr) {
        border-top: 1px solid var(--itr-grey-mid);
        border-bottom: 1px solid var(--itr-grey-mid);
        background-color: #ffffff;
      }

      &--sticky :deep(tr) {
        position: sticky;
        top: 0;
        z-index: 10;
      }
    }
    &__tbody {
      overflow: auto;
      overflow: visible;
      :deep(tr:nth-child(1n)) {
        background-color: rgba(0, 0, 0, 0.05);
      }
      :deep(tr:nth-child(2n)) {
        background-color: #ffffff;
      }
    }
  }
</style>
